const devConsoleOutput: string[] = [];

export const getAllDebugConsoleOutput = () => devConsoleOutput;

const startStoringDevConsoleOuput = () => {
  if (devConsoleOutput.length === 0) {
    devConsoleOutput.push('-- initialized --');
  }
  const consoleError = console.error;
  const consoleLog = console.log;
  const consoleWarn = console.warn;

  console.error = function (...args: unknown[]) {
    const response = consoleError.apply(console, args);
    devConsoleOutput.push(JSON.stringify({ error: args }));
    return response;
  };
  console.warn = function (...args: unknown[]) {
    const response = consoleWarn.apply(console, args);
    devConsoleOutput.push(JSON.stringify({ warn: args }));
    return response;
  };
  console.log = function (...args: unknown[]) {
    const response = consoleLog.apply(console, args);
    devConsoleOutput.push(JSON.stringify({ log: args }));
    return response;
  };

  if (!window) {
    console.warn('No window available to catch errors');
    return;
  }
  window.onerror = function (...args: unknown[]) {
    devConsoleOutput.push(JSON.stringify({ errorOccured: args }));
  };
};

if (
  // To debug mobile browser we will start tracking all output when on /check page
  window?.location?.pathname === '/check' ||
  window?.location?.pathname === '/support/check'
) {
  startStoringDevConsoleOuput();
}

// On other pages, this file will not do anything
